
document.addEventListener("DOMContentLoaded", function() {

  document.addEventListener('click', function (e) {
    if (e.target.closest('.yg-colse-menu')) {
      const parent = e.target.closest('[is="mega-menu-disclosure"]');
      if (parent && parent.open) {
        parent.open = false;
      }
      const mega_menu  = e.target.closest('.mega-menu ');
      if (mega_menu) {
        mega_menu.style.removeProperty('opacity');
      }
    }
  });

  class YGPriceButton extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    _onClick(e) {
      // 找到最近的 product-card 元素或包含 .product-card 的父节点
      const productCard = this.closest('product-card') || this.closest('.product-card');
      if (!productCard) return;

      const quickBuy = productCard.querySelector('.product-card__quick-buy');
      if (!quickBuy) return;

      // 优先触发显式的提交或按钮元素
      const trigger = quickBuy.querySelector('button[type="submit"], button, a, input[type="submit"]');
      if (trigger) {
        trigger.click();
      }
    }
  }

  if (!window.customElements.get('yg-price-button')) {
    window.customElements.define('yg-price-button', YGPriceButton);
  }

  class YGMegaMenuItem extends HTMLElement {
    constructor() {
      super();
      this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('[data-yg-mega-menu-see-more]');

      if (!this.button) return;

      this.button.addEventListener('click', this.handleButtonClick);
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.handleButtonClick);
      }
    }

    handleButtonClick(event) {
      event.preventDefault();
      event.stopPropagation();

      const extraLinks = this.querySelectorAll('[data-yg-mega-menu-extra-link]');

      for (let index = 0; index < extraLinks.length; index += 1) {
        extraLinks[index].removeAttribute('hidden');
      }

      this.button.setAttribute('aria-expanded', 'true');
      this.button.setAttribute('hidden', '');
    }
  }

  if (!window.customElements.get('yg-mega-menu-item')) {
    window.customElements.define('yg-mega-menu-item', YGMegaMenuItem);
  }

  class YGMegaMenu extends YGUtils {
    constructor() {
      super();
      this.tabs = null;
      this.items = null;
      this.tabHandlers = [];
      this.handleResize = this.handleResize.bind(this);
      this.init();
    }
    init() {
      this.tabs = this.querySelectorAll('.yg-collection-tab-item');
      this.items = this.querySelectorAll('.yg-collection-product-item');
      if (this.tabs.length === 0 || this.items.length === 0) return;

      // 初始化高亮和展示
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('active', i === 0);
        if (this.items[i]) this.items[i].classList.toggle('active', i === 0);
      });

      // 根据屏幕宽度设置事件
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    switchTab(index) {
      this.tabs.forEach((t, j) => t.classList.toggle('active', index === j));
      this.items.forEach((p, j) => p.classList.toggle('active', index === j));
    }

    handleResize() {
      const isMobile = window.innerWidth < 1150;

      // 清除现有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
      this.tabHandlers = [];

      // 根据设备类型添加事件
      this.tabs.forEach((tab, i) => {
        let handler;
        let type;

        if (isMobile) {
          // 移动端：点击切换
          type = 'click';
          handler = () => this.switchTab(i);
        } else {
          // 桌面端：悬浮切换
          type = 'mouseenter';
          handler = () => this.switchTab(i);
        }

        tab.addEventListener(type, handler);
        this.tabHandlers.push({ tab, handler, type });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      // 清除所有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
    }
  }
  if (!window.customElements.get('yg-mega-menu')) {
    window.customElements.define('yg-mega-menu', YGMegaMenu);
  }

  class YGCategorySwiper extends YGUtils {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 2,
        spaceBetween: 8,
      });
    }
  }

  if (!window.customElements.get('yg-category-swiper')) {
    window.customElements.define('yg-category-swiper', YGCategorySwiper);
  }

  class YGKeyFeatures extends YGUtils {
    constructor() {
      super();
      this.handleToggle = this.handleToggle.bind(this);
    }

    connectedCallback() {
      const content = this.querySelector('.yg-key-features-content');

      // 默认展开
      if (content) {
        content.classList.add('active');
      }

      this.addEventListener('click', this.handleToggle);
      this.updateButtonState();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleToggle);
    }

    handleToggle(event) {
      const button = event.target.closest('.yg-key-btn');
      if (!button || !this.contains(button)) return;

      const content = this.querySelector('.yg-key-features-content');
      const textEl = this.querySelector('.yg-learn-more-button-text');
      const icon = this.querySelector('.yg-learn-more-button-icon');

      if (!content || !textEl) return;

      const isActive = content.classList.toggle('active');

      this.setButtonText(textEl, isActive);
      this.setIconRotation(icon, isActive);
    }

    updateButtonState() {
      const content = this.querySelector('.yg-key-features-content');
      const textEl = this.querySelector('.yg-learn-more-button-text');
      const icon = this.querySelector('.yg-learn-more-button-icon');

      if (!content || !textEl) return;

      const isActive = content.classList.contains('active');

      this.setButtonText(textEl, isActive);
      this.setIconRotation(icon, isActive);
    }

    setButtonText(textEl, isActive) {
      const moreText =
        textEl.getAttribute('data-more-text') ||
        'Learn more';

      const lessText =
        textEl.getAttribute('data-less-text') ||
        'Learn less';

      textEl.textContent = isActive ? lessText : moreText;
    }

    setIconRotation(icon, isActive) {
      if (!icon) return;

      icon.style.transition = 'transform .2s ease-in-out';
      icon.style.transform = isActive
        ? 'rotate(180deg)'
        : 'rotate(0deg)';
    }
  }
  
  if (!window.customElements.get('yg-key-features')) {
    window.customElements.define('yg-key-features', YGKeyFeatures);
  }
})
